import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { AppMaterialModule } from '../../shared/appMaterial/app-material.module';
import { MessagingDashboardComponent } from './messaging-dashboard.component';
import { MessagingResolve } from './messaging-dashboard.resolve';
import { CometChatService } from '../../../core/services/cometChat/cometChat.service';
import { CometChatCoreService } from '../../../core/services/cometChat/cometChatCore.service';
import { CometChatSuperAdminService } from '../../../core/services/cometChat/cometChatSuperAdmin.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatChipsModule } from '@angular/material/chips';
import { AdminContextModule } from './context/admin/admin.module';
import { OwnerContextModule } from './context/owner/owner.module';
import { CaptainContextModule } from './context/captain/captain.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AppMaterialModule,
    MatIconModule,
    MatButtonModule,
    MatSnackBarModule,
    MatChipsModule,
    AdminContextModule,
    OwnerContextModule,
    CaptainContextModule,
  ],
  declarations: [MessagingDashboardComponent],
  exports: [MessagingDashboardComponent],
  bootstrap: [MessagingDashboardComponent],
  providers: [
    CometChatCoreService,
    CometChatService,
    CometChatSuperAdminService,
    MessagingResolve,
  ],
})
export class MessagingModule {}
